import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import { mdiPlus } from '@mdi/js';
import Icon from '@mdi/react';
import { DEFAULT_ADDITIONAL_SALARY_TYPES, RECORD_TYPE } from 'LixaniAPI/enums';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AllowanceDialog from '../AllowanceDialog/AllowanceDialog';
import AllowanceTimeframeItem from './AllowanceTimeframeItem';
import { RecordAllowanceItem } from './RecordAllowanceItem';
import { selectSelectedClockOutRecordResourceEmployerAllowances } from 'store/employerAllowances/selectors/record-employer-allowances.selectors';
import { selectAllowancesCreateParams } from 'store/records/selectors/records-base.selectors';

const useStyles = makeStyles((theme) => ({
  addButton: {
    backgroundColor: theme.palette.buttonPrimary,
    borderRadius: 4,
    boxSizing: 'border-box',
    textTransform: 'none',
    boxShadow: theme.shadows[1],
    marginTop: '8px',
  },
  icon: {
    width: '100%',
    height: '100%',
  },
}));

export default function Allowances() {
  const { t } = useTranslation('common');

  const classes = useStyles();

  const [allowanceDialogOpen, setAllowanceDialogOpen] = useState(false);

  const allowancesCreateParams = useSelector(selectAllowancesCreateParams);

  const employerAllowances = useSelector(
    selectSelectedClockOutRecordResourceEmployerAllowances
  );

  const timeFramedAllowanceTypes = Object.values(
    DEFAULT_ADDITIONAL_SALARY_TYPES
  )
    .filter((salaryType) => salaryType.baseType === 'ABSENCE')
    .map((salaryType) => salaryType.salaryType);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="subtitle1" fontWeight="bold">
            {t('record.allowances')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {allowancesCreateParams.map((createParams, index) => {
            const isTimeFramedAllowance = createParams.type.includes('ABSENCE');

            if (isTimeFramedAllowance) {
              return (
                <AllowanceTimeframeItem
                  name={t(
                    `report.salaries.${createParams.salaryType}`.toLowerCase()
                  )}
                  startDate={createParams.startDate}
                  endDate={createParams.endDate}
                  key={index}
                ></AllowanceTimeframeItem>
              );
            } else {
              return (
                <RecordAllowanceItem
                  name={t(
                    DEFAULT_ADDITIONAL_SALARY_TYPES[createParams.salaryType]
                      .salaryName
                  )}
                  unit={
                    employerAllowances.find(
                      (allowance) =>
                        allowance.salaryType === createParams.salaryType
                    ).unit
                  }
                  unitCount={createParams.unitCount}
                  key={index}
                ></RecordAllowanceItem>
              );
            }
          })}
        </Grid>
        <Grid item xs={12}>
          <Button
            className={classes.addButton}
            endIcon={<Icon path={mdiPlus} size={1}></Icon>}
            onClick={() => setAllowanceDialogOpen(true)}
          >
            {t('common.add')}
          </Button>
        </Grid>
      </Grid>

      {allowanceDialogOpen ? (
        <AllowanceDialog
          open={allowanceDialogOpen}
          setDialogOpen={(value) => setAllowanceDialogOpen(value)}
          timeFramedAllowanceTypes={timeFramedAllowanceTypes}
        ></AllowanceDialog>
      ) : null}
    </>
  );
}
